// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1451":"81cb8cba","5448":"6309f616","6155":"35d46e80","6238":"81cb8cba","6455":"4d48948a","8229":"067c2579"}[chunkId] + ".chunk.css";
};